import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Modal } from 'semantic-ui-react';
import { Route } from 'react-router-dom';
import lf from 'services/localforage';
import withGuard from 'services/guard';

import SidebarContainer from 'containers/SidebarContainer';

import CloseButton from 'components/CloseButton';
import TitleWithShape from 'components/TitleWithShape';
import ProgressNav from 'components/ProgressNav';
import Footer from 'components/Footer';
import IconButton from 'components/IconButton';

import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import Step6 from './Step6';
import Step7 from './Step7';
import Step8 from './Step8';
import Step9 from './Step9';
import Step10 from './Step10';

const ModalWrapper = styled.div`
  .header {
    display: flex;
    justify-content: flex-end;
    padding-right: 1rem;
    padding-top: 1rem;
  }
  .content {
    padding: 6.3rem 9.5rem;
    .options-wrapper {
      margin-top: 4.7rem;
      display: flex;
    }
    .next-button {
      display: flex;
      justify-content: flex-end;
      margin-top: 7rem;
    }
  }
`;

const progressRoutes = [
  { url: '/get-started', step: 1 },
  { url: '/get-started/step-two', step: 2 },
  { url: '/get-started/step-three', step: 3 },
  { url: '/get-started/step-four', step: 4 },
  { url: '/get-started/step-five', step: 5 },
  { url: '/get-started/step-six', step: 6 },
  { url: '/get-started/step-seven', step: 7 },
  { url: '/get-started/step-eight', step: 8 },
  { url: '/get-started/step-nine', step: 9 },
  { url: '/get-started/step-ten', step: 10 },
];

class BeginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    lf.getFormData().then(session => this.setState(session));
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  setForWho = (val) => {
    const { index } = this.state;
    index.forWho = val;
    this.setState({ index });
  }

  collectData = (key, val) => {
    this.setState({ [key]: val }, () => {
      lf.store.setItem('session', this.state);
    });
  }

  finaliseForm = () => {
    const { step10 } = this.state;
    step10.emailSent = true;
    this.setState({ step10 }, () => lf.store.clear());
  }

  handleSidebar = () => {
    this.setState({ isVisible: !this.state.isVisible });
  }

  toggleModal = () => {
    const { index } = this.state;
    index.showModal = !index.showModal;
    this.setState({ index }, () => {
      this.collectData('index', this.state.index);
    });
  }

  render() {
    const { match } = this.props;

    return (
      <SidebarContainer
        visible={this.state.isVisible}
        page="begin"
      >

        {Object.keys(this.state).length > 0 && (
          <div>
            <ProgressNav routes={progressRoutes} session={this.state} />
            <div>
              <Route
                exact
                path={match.url}
                render={routeProps => <Step1 {...routeProps} collectData={this.collectData} formData={this.state.step1} forWho={this.state.index.forWho} startOver={this.toggleModal} />}
              />
              <Route
                exact
                path={`${match.url}/step-two`}
                render={routeProps => withGuard(<Step2 {...routeProps} collectData={this.collectData} formData={this.state.step2} />, this.state, 2)}
              />
              <Route
                exact
                path={`${match.url}/step-three`}
                render={routeProps => withGuard(<Step3 {...routeProps} collectData={this.collectData} formData={this.state.step3} />, this.state, 3)}
              />
              <Route
                exact
                path={`${match.url}/step-four`}
                render={routeProps => withGuard(<Step4 {...routeProps} collectData={this.collectData} formData={this.state.step4} />, this.state, 4)}
              />
              <Route
                exact
                path={`${match.url}/step-five`}
                render={routeProps => withGuard(<Step5 {...routeProps} collectData={this.collectData} documents={this.state.documents} formData={this.state.step5} uuid={this.state.uuid} />, this.state, 5)}
              />
              <Route
                exact
                path={`${match.url}/step-six`}
                render={routeProps => withGuard(<Step6 {...routeProps} collectData={this.collectData} documents={this.state.documents} formData={this.state.step6} uuid={this.state.uuid} />, this.state, 6)}
              />
              <Route
                exact
                path={`${match.url}/step-seven`}
                render={routeProps => withGuard(<Step7 {...routeProps} collectData={this.collectData} formData={this.state.step7} />, this.state, 7)}
              />
              <Route
                exact
                path={`${match.url}/step-eight`}
                render={routeProps => withGuard(<Step8 {...routeProps} collectData={this.collectData} formData={this.state} />, this.state, 8)}
              />
              <Route
                exact
                path={`${match.url}/step-nine`}
                render={routeProps => withGuard(<Step9 {...routeProps} collectData={this.collectData} formData={this.state.step9} name={this.state.step1.name} email={this.state.step1.email} />, this.state, 9)}
              />
              <Route
                exact
                path={`${match.url}/step-ten`}
                render={routeProps => withGuard(<Step10 {...routeProps} collectData={this.collectData} finaliseForm={() => this.finaliseForm()} formData={this.state} />, this.state, 10)}
              />
            </div>
            <Footer />
            <Modal
              open={this.state.index.showModal}
              size="large"
              closeOnDocumentClick={false}
              closeOnDimmerClick={false}
            >
              <Modal.Content>
                <ModalWrapper>
                  <div className="header">
                    <CloseButton onClick={this.toggleModal} />
                  </div>
                  <div className="content">
                    <TitleWithShape
                      title="Are you asking for yourself or someone else?"
                      subTitle="Someone else could include the company you work for or a family member who wants you to ask a question on their behalf."
                    />
                    <div className="options-wrapper">
                      <IconButton
                        name="Myself"
                        icon="circle"
                        selected={this.state.index.forWho === 'me'}
                        onClick={() => this.setForWho('me')}
                        rightMargin={1}
                      />
                      <IconButton
                        name="Someone else"
                        icon="circle"
                        selected={this.state.index.forWho === 'other'}
                        onClick={() => this.setForWho('other')}
                      />
                    </div>
                    <div className="next-button">
                      <IconButton
                        name="Next"
                        icon="rightArrow"
                        onClick={this.toggleModal}
                        selected
                        noBorder
                      />
                    </div>
                  </div>
                </ModalWrapper>
              </Modal.Content>
            </Modal>
          </div>
        )}

      </SidebarContainer>
    );
  }
}

BeginPage.propTypes = {
  match: PropTypes.shape.isRequired,
};

export default BeginPage;



// WEBPACK FOOTER //
// ./src/containers/BeginPage/index.js